"use client";
import { InputNumber } from "antd";
import type { InputNumberProps } from "antd";

interface AppNumberProps extends InputNumberProps {
  type?: "int" | "decimal";
}

function AppNumber({ type = "int", ...props }: AppNumberProps) {
  return (
    <InputNumber
      style={{ width: "100%" }}
      step={props.step || (type === "decimal" ? 0.01 : 1)}
      precision={type === "decimal" ? 2 : 0}
      stringMode={type === "decimal"}
      {...props}
    />
  );
}

export default AppNumber;
